import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';

//--- Styles
// import '../news.scss';

//--- Material Control
import {
    DialogActions,
    Button,
    TextField,
    DialogContent,
    DialogTitle,
    Dialog,
    Typography,
    IconButton,
    makeStyles,
    Checkbox,
} from '@material-ui/core';

//--- Material Icon
import CloseIcon from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import ShowNotification from '../../../components/react-notifications/react-notifications';
import {
    NotificationMessageType,
    APIUrlDefault,
    MaxSizeImageUpload,
} from '../../../utils/configuration';
import * as viVN from '../../../language/vi-VN.json';
import * as editionAction from "../../../redux/store/edition/edition.store"

const useStyles = makeStyles((theme) => ({
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
    formControl: {
        margin: theme.spacing(1),
    },
}));
const EditEdition = (props) => {
    const {
        item,
        isOpen,
        onClose,
        onSuccess,
        GetListAll,
        rowsPerPage,
        setOrder,
        setOrderBy,
    } = props;
    const classes = useStyles();

    const { register, handleSubmit, setError, errors, clearErrors, setValue } =
        useForm({
            mode: 'all',
            reValidateMode: 'onBlur',
        });

    const onSubmit = (data) => {
        console.log('data', data)
        const params = {
            id: item.id,
            name: [
                {
                    langId: 'vi',
                    value: data.name,
                }
            ],
            description: [
                {
                    langId: 'vi',
                    value: data.description,
                }
            ],
            numberOfDay: parseInt(data.numberOfDay),
            price: parseInt(data.price),

        }
        editionAction.EditionUpdate(params).then(res => {
            if (res && res.content) {
                onClose();
                GetListAll();
                ShowNotification(
                    'Thêm mới thành công',
                    NotificationMessageType.Success
                );
            }
        }).catch(err => {
            console.log(err)
        })
    }

    return (
        <Dialog open={isOpen} onClose={onClose} fullWidth={true} maxWidth='md'>
            <DialogTitle disableTypography className='border-bottom'>
                <Typography variant='h6'>Thêm gói thành viên</Typography>
                <IconButton
                    aria-label='close'
                    className={classes.closeButton}
                    onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <form onSubmit={handleSubmit(onSubmit)} autoComplete='off'>
                <DialogContent className='pt-4 pb-2'>
                    <div className='row form-group'>
                        <div className="col-lg-6">
                            <label className='text-dark'>
                                Tên gói<span className='required'></span>
                            </label>
                            <TextField
                                name='name'
                                error={
                                    errors.name &&
                                    (errors.name.type === 'required' ||
                                        errors.name.type === 'maxLength')
                                }
                                fullWidth
                                type='text'
                                className='form-control'
                                inputProps={{ maxLength: 150 }}
                                inputRef={register({ required: true, maxLength: 150 })}
                                defaultValue={item.name[0].value}
                                onChange={(e) => setValue('name', e.target.value)}
                            />
                            {errors.name && errors.name.type === 'required' && (
                                <span className='error'>Trường này là bắt buộc</span>
                            )}
                            {errors.name && errors.name.type === 'maxLength' && (
                                <span className='error'>Trường này không quá 150 ký tự</span>
                            )}
                        </div>
                        <div className="col-lg-6">
                            <label className='text-dark'>
                                Ghi chú<span className='required'></span>
                            </label>
                            <TextField
                                name='description'
                                error={
                                    errors.description &&
                                    (errors.description.type === 'required' ||
                                        errors.description.type === 'maxLength')
                                }
                                fullWidth
                                type='text'
                                className='form-control'
                                inputProps={{ maxLength: 150 }}
                                inputRef={register({ required: true, maxLength: 150 })}
                                defaultValue={item.description[0].value}
                                onChange={(e) => setValue('description', e.target.value)}
                            />
                            {errors.description && errors.description.type === 'required' && (
                                <span className='error'>Trường này là bắt buộc</span>
                            )}
                            {errors.description && errors.description.type === 'maxLength' && (
                                <span className='error'>Trường này không quá 150 ký tự</span>
                            )}
                        </div>
                    </div>
                    <div className='row form-group'>
                        <div className="col-lg-6">
                            <label className='text-dark'>
                                Giá tiền<span className='required'></span>
                            </label>
                            <TextField
                                name='price'
                                error={
                                    errors.price &&
                                    (errors.price.type === 'required' ||
                                        errors.price.type === 'maxLength')
                                }
                                fullWidth
                                type='number'
                                className='form-control'
                                inputProps={{ maxLength: 150 }}
                                inputRef={register({ required: true, maxLength: 150 })}
                                defaultValue={item.price}
                                onChange={(e) => setValue('price', e.target.value)}
                            />
                            {errors.price && errors.price.type === 'required' && (
                                <span className='error'>Trường này là bắt buộc</span>
                            )}
                            {errors.price && errors.price.type === 'maxLength' && (
                                <span className='error'>Trường này không quá 150 ký tự</span>
                            )}
                        </div>
                        <div className="col-lg-6">
                            <label className='text-dark'>
                                Số ngày sử dụng<span className='required'></span>
                            </label>
                            <TextField
                                name='numberOfDay'
                                error={
                                    errors.numberOfDay &&
                                    (errors.numberOfDay.type === 'required' ||
                                        errors.numberOfDay.type === 'maxLength')
                                }
                                fullWidth
                                type='number'
                                className='form-control'
                                inputProps={{ maxLength: 150 }}
                                inputRef={register({ required: true, maxLength: 150 })}
                                defaultValue={item.numberOfDay}
                                onChange={(e) => setValue('numberOfDay', e.target.value)}
                            />
                            {errors.numberOfDay && errors.numberOfDay.type === 'required' && (
                                <span className='error'>Trường này là bắt buộc</span>
                            )}
                            {errors.numberOfDay && errors.numberOfDay.type === 'maxLength' && (
                                <span className='error'>Trường này không quá 150 ký tự</span>
                            )}
                        </div>
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button
                        type="submit"
                        color="primary"
                        variant="contained"
                    //   startIcon={!isSubmitting ? <SaveIcon></SaveIcon> : <CircularProgress size={20} color="white"/>}
                    //   disabled={isSubmitting}
                    >
                        Lưu
                    </Button>

                </DialogActions>
            </form>
        </Dialog>
    )
}

export default EditEdition;